import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { queryTypes, serviceInjectionTypes } from 'src/types';
import { fileHelper, urlHelper } from '../helpers';

export const lookupInjection = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceInjectionTypes.InjectionLookupDataType): AxiosPromise<serviceInjectionTypes.InjectionLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.injection.lookupInjection), {
    blockSpinner,
  });
};

export const lookupInjectionTable = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceInjectionTypes.InjectionLookupDataType): AxiosPromise<serviceInjectionTypes.InjectionTableLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    return axios.get(urlHelper.addQueryParameters({ search: value }, urlsConfig.injection.lookupInjection), {
      blockSpinner,
    });
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.injection.lookupInjection), {
    blockSpinner,
  });
};

export const createInjection = (
  form: serviceInjectionTypes.InjectionCreateDataType,
  // formData: FormData,
  options: { blockErrorHandler: boolean },
): AxiosPromise<serviceInjectionTypes.InjectionCreateResultType> => {
  const entitiesData = fileHelper.convertArrayData(form.injectedAudienceEntities);
  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.incidentNumberId) {
    formData.append('incidentNumberId', form.incidentNumberId);
  }

  if (form.injectionNumber) {
    formData.append('injectionNumber', form.injectionNumber);
  }

  if (form.injectionName) {
    formData.append('injectionName', form.injectionName);
  }

  if (form.scriptedById) {
    formData.append('scriptedById', form.scriptedById);
  }

  if (form.scriptedDateTime) {
    formData.append('scriptedDateTime', form.scriptedDateTime.toString());
  }

  if (form.modifiedById) {
    formData.append('modifiedById', form.modifiedById);
  }

  if (form.modifiedDateTime) {
    formData.append('modifiedDateTime', form.modifiedDateTime.toString());
  }

  if (form.injectorId) {
    formData.append('injectorId', form.injectorId);
  }

  if (form.injectionDirection) {
    formData.append('injectionDirection', form.injectionDirection);
  }

  if (form.injectedAudienceEntities) {
    form.injectedAudienceEntities.forEach((e) => formData.append('injectedAudienceEntities', e as any as string));
  }

  if (form.injectionType) {
    formData.append('injectionType', form.injectionType);
  }

  if (form.dateTimeGroup) {
    formData.append('dateTimeGroup', form.dateTimeGroup.toString());
  }
  if (form.timeDetails) {
    formData.append('timeDetails', JSON.stringify(form.timeDetails));
  }

  if (form.type) {
    formData.append('type', form.type.toString());
  }

  if (form.injectionReferenceId) {
    formData.append('injectionReferenceId', form.injectionReferenceId);
  }

  if (form.actionReferenceId) {
    formData.append('actionReferenceId', form.actionReferenceId);
  }

  if (form.injectionMeanId) {
    formData.append('injectionMeanId', form.injectionMeanId);
  }

  if (form.injectionLocationId) {
    formData.append('injectionLocationId', form.injectionLocationId);
  }

  if (form.description) {
    formData.append('description', form.description);
  } else {
    formData.append('description', '');
  }

  if (form.coordinationRemarks) {
    formData.append('coordinationRemarks', form.coordinationRemarks);
  } else {
    formData.append('coordinationRemarks', '');
  }

  if (form.functionalAreaMessage) {
    formData.append('functionalAreaMessage', form.functionalAreaMessage);
  }

  if (form.log) {
    formData.append('log', form.log);
  }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }

  if (form.injectionStatusId) {
    formData.append('injectionStatusId', form.injectionStatusId);
  }
  formData.append('isAnchor', form.isAnchor.toString());

  return axios.post(urlsConfig.injection.createInjection, formData, { blockErrorHandler: true });
};

export const injectionEdit = (
  form: serviceInjectionTypes.InjectionEditDataType,
  // formData: FormData,
): AxiosPromise<serviceInjectionTypes.InjectionEditResultType> => {
  const entitiesData = fileHelper.convertArrayData(form.injectedAudienceEntities);

  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.id !== undefined) {
    formData.append('id', form.id);
  }

  if (form.deletedAttachments !== undefined) {
    form.deletedAttachments.forEach((eachAttachment: any) => {
      formData.append('deletedAttachments', eachAttachment);
    });
  }

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.incidentNumberId) {
    formData.append('incidentNumberId', form.incidentNumberId);
  }

  if (form.injectionNumber) {
    formData.append('injectionNumber', form.injectionNumber);
  }

  if (form.injectionName) {
    formData.append('injectionName', form.injectionName);
  }

  if (form.scriptedById) {
    formData.append('scriptedById', form.scriptedById);
  }

  if (form.scriptedDateTime) {
    formData.append('scriptedDateTime', form.scriptedDateTime.toString());
  }

  if (form.modifiedById) {
    formData.append('modifiedById', form.modifiedById);
  }

  if (form.modifiedDateTime) {
    formData.append('modifiedDateTime', form.modifiedDateTime.toString());
  }

  if (form.injectorId) {
    formData.append('injectorId', form.injectorId);
  }

  if (form.injectionDirection) {
    formData.append('injectionDirection', form.injectionDirection);
  }

  if (form.injectedAudienceEntities) {
    form.injectedAudienceEntities.forEach((e) => formData.append('injectedAudienceEntities', e as any as string));
  }

  if (form.injectionType) {
    formData.append('injectionType', form.injectionType);
  }

  if (form.dateTimeGroup) {
    formData.append('dateTimeGroup', form.dateTimeGroup.toString());
  }
  // else {
  //   formData.append('dateTimeGroup', '0');
  // }

  if (form.timeDetails) {
    formData.append('timeDetails', JSON.stringify(form.timeDetails));
  }

  if (form.type) {
    formData.append('type', form.type.toString());
  }

  if (form.injectionReferenceId) {
    formData.append('injectionReferenceId', form.injectionReferenceId);
  }

  if (form.actionReferenceId) {
    formData.append('actionReferenceId', form.actionReferenceId);
  }

  if (form.injectionMeanId) {
    formData.append('injectionMeanId', form.injectionMeanId);
  }

  if (form.injectionLocationId) {
    formData.append('injectionLocationId', form.injectionLocationId);
  }

  if (form.description) {
    formData.append('description', form.description);
  } else {
    formData.append('description', '');
  }

  if (form.coordinationRemarks) {
    formData.append('coordinationRemarks', form.coordinationRemarks);
  } else {
    formData.append('coordinationRemarks', '');
  }

  if (form.functionalAreaMessage) {
    formData.append('functionalAreaMessage', form.functionalAreaMessage);
  }

  if (form.log) {
    formData.append('log', form.log);
  }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }

  if (form.injectionStatusId) {
    formData.append('injectionStatusId', form.injectionStatusId);
  }

  formData.append('isAnchor', form.isAnchor.toString());

  return axios.patch(urlsConfig.injection.injectionEdit, formData, { blockErrorHandler: true });
};

export const injectionDelete = ({
  id,
}: serviceInjectionTypes.InjectionDeleteDataType): AxiosPromise<serviceInjectionTypes.InjectionDeleteResultType> => {
  return axios.delete(`${urlsConfig.injection.injectionDelete}/${id}`);
};
